const styles = {
	wrapper: {
		paddingY: 20,
		borderBottomWidth: 1,
		borderBottomStyle: 'solid',
		borderBottomColor: 'muted',
		pointerEvent: 'all',
		'&:hover': {
			button: {
				opacity: 1,
				visibility: 'visible',
			},
		},
	},
	imageWrapper: {
		width: [90, 105],
		height: [90, 105],
		position: 'relative',
		overflow: 'hidden',
		borderRadius: 6,
		img: {
			width: '100%',
			height: '100%',
			objectFit: 'cover',
		},
		button: {
			opacity: 0,
			visibility: 'hidden',
			position: 'absolute',
			width: '100%',
			top: 0,
			height: '100%',
			backgroundColor: 'rgba(0, 0, 0, 0.25)',
			color: 'white',
			transition: 'all 0.3s ease',
		},
	},
	contentWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		width: ['calc(100% - 90px)', 'calc(100% - 105px)'],
		paddingLeft: 15,
	},
	title: {
		fontSize: 0,
		marginBottom: 10,
	},
	unitPrice: {
		color: 'darkgray',
		fontSize: 0,
	},
	totalPrice: {
		color: 'primary',
		fontWeight: 700,
		fontSize: 0,
	},
	counterWrapper: {
		display: 'flex',
		flexDirection: 'column-reverse',
		justifyContent: 'space-between',
		alignItems: 'flex-end',
		marginTop: [20, 0],
	},
	cartCounter: {
		display: 'flex',
		alignItems: 'center',
		minWidth: 106,
		minHeight: 36,
		borderRadius: 6,
		overflow: 'hidden',
		backgroundColor: 'primary',
		boxShadow: '0 6px 12px rgba(0, 0, 0, 0.16)',
		input: {
			width: 48,
			border: 0,
			color: 'white',
			textAlign: 'center',
			fontSize: 0,
			fontWeight: 700,
			paddingLeft: 0,
			paddingRight: 0,
			MozAppearance: 'textfield',
			'::-webkit-outer-spin-button, ::-webkit-inner-spin-button': {
				WebkitAppearance: 'none',
				margin: 0,
			},
			':focus': {
				outline: 'none',
			},
		},
		button: {
			padding: 0,
			minWidth: 32,
			minHeight: 36,
			svg: {
				width: 24,
				marginLeft: 0,
			},
		},
	},
};

export default styles;
